export default () => {
  const el = document.querySelector('.page-header__wishlist-count');
  const mobileEl = document.querySelector('.mobile-wishlist__count');
  if (el) {
    setTimeout(() => {
      // eslint-disable-next-line no-underscore-dangle
      window._swat.wishlistCount((count) => {
        if (count > 0) {
          el.innerHTML = `${count}`;
          mobileEl.innerHTML = `${count}`;
        } else {
          el.innerHTML = '';
          mobileEl.innerHTML = '';
        }
      });
    }, 500);
  }
};
